(function () {
  var DAY_NAMES = [
    'Sonntag',
    'Montag',
    'Dienstag',
    'Mittwoch',
    'Donnerstag',
    'Freitag',
    'Samstag',
  ];

  function parseDate(value) {
    var parts = String(value).split('-');
    return new Date(
      Number(parts[0]),
      Number(parts[1]) - 1,
      Number(parts[2])
    );
  }

  function formatDate(date) {
    var day = String(date.getDate()).padStart(2, '0');
    var month = String(date.getMonth() + 1).padStart(2, '0');
    var year = String(date.getFullYear()).slice(-2);
    return day + '.' + month + '.' + year;
  }

  function formatDateRange(arrivalDate, departureDate) {
    var arrival = parseDate(arrivalDate);
    var arrivalLabel = DAY_NAMES[arrival.getDay()] + ', ' + formatDate(arrival);

    if (arrivalDate === departureDate) {
      return arrivalLabel;
    }

    var departure = parseDate(departureDate);
    return (
      DAY_NAMES[arrival.getDay()] +
      ' ' +
      formatDate(arrival) +
      ' - ' +
      DAY_NAMES[departure.getDay()] +
      ' ' +
      formatDate(departure)
    );
  }

  function hasEnded(stop) {
    var departure = parseDate(stop.departure_date);
    departure.setHours(23, 59, 59, 999);
    return departure < new Date();
  }

  function limitPast(stops, pastCount) {
    var past = stops.filter(hasEnded);
    var current = stops.filter(function (stop) {
      return !hasEnded(stop);
    });
    return past.slice(Math.max(0, past.length - pastCount)).concat(current);
  }

  function line(parent, className, text) {
    if (!text) return;
    var el = document.createElement('div');
    el.className = className;
    el.textContent = text;
    parent.appendChild(el);
  }

  function buildStop(stop, options) {
    var card = document.createElement('div');
    card.className = 'roadshow-stop';

    if (options.dimPast && hasEnded(stop)) {
      card.className += ' roadshow-stop--past';
    }

    line(card, 'roadshow-stop__name', stop.name);
    line(
      card,
      'roadshow-stop__dates',
      formatDateRange(stop.arrival_date, stop.departure_date)
    );

    if (stop.type === 'manual_other') {
      line(card, 'roadshow-stop__note', 'Wir suchen einen Standort');
      return card;
    }

    line(card, 'roadshow-stop__address', stop.address);

    var cityLine = [stop.zip_code, stop.city].filter(Boolean).join(' ');
    line(card, 'roadshow-stop__city', cityLine);

    line(card, 'roadshow-stop__hours', stop.note);

    if (options.mapsLink && stop.address && !stop.note) {
      var link = document.createElement('a');
      link.className = 'roadshow-stop__link';
      link.href =
        'https://www.google.com/maps/dir/?api=1&destination=' +
        encodeURIComponent(stop.address);
      link.target = '_blank';
      link.rel = 'noopener noreferrer';
      link.textContent = 'In Google Maps öffnen';
      card.appendChild(link);
    }

    return card;
  }

  function cardLines(stop) {
    var lines = [formatDateRange(stop.arrival_date, stop.departure_date)];

    if (stop.type === 'manual_other') {
      return lines.concat('Wir suchen einen Standort');
    }

    lines.push(stop.address);
    lines.push([stop.zip_code, stop.city].filter(Boolean).join(' '));

    String(stop.note || '')
      .split('\n')
      .forEach(function (noteLine) {
        lines.push(noteLine.trim());
      });

    return lines.filter(Boolean);
  }

  function buildCard(stop, options) {
    var card = document.createElement('div');
    card.className =
      'multicolumn-card with-border card flex gap-5 w-full flex-col items-start xl:flex-row text-center';

    var inner = document.createElement('div');
    inner.className = 'grid gap-4 lg:gap-6 w-full';

    var info = document.createElement('div');
    info.className = 'multicolumn-card__info grid gap-4 lg:gap-6';

    var heading = document.createElement('p');
    heading.className =
      'heading ' + options.cardHeadingSize + ' leading-tight tracking-tight';
    var strong = document.createElement('strong');
    strong.textContent = stop.name;
    heading.appendChild(strong);
    info.appendChild(heading);

    var text = document.createElement('div');
    text.className = 'rte leading-normal';
    var paragraph = document.createElement('p');
    cardLines(stop).forEach(function (textLine, index) {
      if (index > 0) paragraph.appendChild(document.createElement('br'));
      paragraph.appendChild(document.createTextNode(textLine));
    });
    text.appendChild(paragraph);
    info.appendChild(text);

    inner.appendChild(info);
    card.appendChild(inner);
    return card;
  }

  function render(root) {
    var status = root.querySelector('[data-roadshow-status]');
    var list = root.querySelector('[data-roadshow-list]');
    var base = (root.dataset.apiBase || '').replace(/\/+$/, '');

    var pastCount = parseInt(root.dataset.pastCount, 10) || 0;
    var limit = parseInt(root.dataset.limit, 10) || 0;

    var url =
      base +
      '/api/public/embed/tour-stops' +
      (pastCount > 0 ? '?include_past=true' : '');

    var options = {
      dimPast: root.dataset.dimPast === 'true',
      mapsLink: root.dataset.mapsLink === 'true',
      cardHeadingSize: root.dataset.cardHeadingSize || 'text-base-xl',
    };

    var build = root.dataset.layout === 'cards' ? buildCard : buildStop;

    fetch(url, { headers: { Accept: 'application/json' } })
      .then(function (response) {
        if (!response.ok) throw new Error('HTTP ' + response.status);
        return response.json();
      })
      .then(function (payload) {
        var stops = (payload && payload.data && payload.data.stops) || [];

        if (pastCount > 0) {
          stops = limitPast(stops, pastCount);
        }

        if (limit > 0) {
          stops = stops.slice(0, limit);
        }

        if (!stops.length) {
          status.textContent = root.dataset.emptyText || 'Aktuell sind keine Termine geplant.';
          return;
        }

        var fragment = document.createDocumentFragment();
        stops.forEach(function (stop) {
          fragment.appendChild(build(stop, options));
        });

        list.appendChild(fragment);
        list.hidden = false;
        status.remove();
      })
      .catch(function (error) {
        console.error('[roadshow-stops]', error);
        status.textContent =
          root.dataset.errorText || 'Die Termine können gerade nicht geladen werden.';
      });
  }

  function init(scope) {
    (scope || document)
      .querySelectorAll('[data-roadshow-stops]')
      .forEach(function (root) {
        if (root.dataset.roadshowInitialised === 'true') return;
        root.dataset.roadshowInitialised = 'true';
        render(root);
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
